<template></template>

<script>
  export default {
    name: 'bookPerBatchModal',
  };
</script>

<style scoped>

</style>
